// Minimal stand-in for class-variance-authority's `cva`, covering exactly what
// the copied Badge and Button use: a base class string, named variant groups,
// and default variants. Avoids adding the dependency to Mosaico for two files.
type VariantSchema = Record<string, Record<string, string>>

type VariantSelection<V extends VariantSchema> = {
  [K in keyof V]?: keyof V[K] | null
}

export function cva<V extends VariantSchema>(
  base: string,
  config?: { variants?: V; defaultVariants?: VariantSelection<V> },
): (props?: VariantSelection<V>) => string {
  return (props = {}) => {
    const classes = [base]
    const variants = config?.variants ?? ({} as V)
    for (const key of Object.keys(variants) as Array<keyof V>) {
      const chosen = props[key] ?? config?.defaultVariants?.[key]
      if (chosen != null) {
        const cls = variants[key][chosen as string]
        if (cls) classes.push(cls)
      }
    }
    return classes.join(' ')
  }
}

export type VariantProps<T extends (props?: any) => string> = NonNullable<Parameters<T>[0]>
